/* Loading-state placeholder. Renders a 5×11 grid of empty cells —
   five rows is roughly half the median puzzle's guess budget; eleven
   columns is the median palindrome length in the published corpus.
   Same `.row` / `.cell` classes as the real Board so the skeleton's
   dimensions match what arrives, eliminating CLS at puzzle-arrival
   time (briefs/seo.md §"Core Web Vitals" — CLS < 0.1).

   Rendered by BoardScroll while puzzle is null; replaced atomically
   by <Board /> the moment loadInitialPuzzle resolves. */

const ROWS = 5;
const COLS = 11;

export function BoardSkeleton() {
  const rows: preact.JSX.Element[] = [];
  for (let r = 0; r < ROWS; r++) {
    const cells: preact.JSX.Element[] = [];
    for (let c = 0; c < COLS; c++) {
      cells.push(<div class="cell" key={`s-${r}-${c}`} />);
    }
    rows.push(
      <div class="row" key={`r-${r}`} aria-hidden="true">
        {cells}
      </div>,
    );
  }
  return <div class="board board--skeleton">{rows}</div>;
}
